<div class="p-4 md:p-6 max-w-6xl mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-2">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">calculate</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">RAIL COLOMBIA — Calculadora</h1>
  </div>
  <p class="text-xs text-gray-500 mb-6">
    Modelo del xls <em>carlos estimacion COP</em> con tasas reales: referencia B3 = tasa <strong>pública de Vita</strong>; mercado (Investing) informativo + tasa de compra Vita del tramo BREB (B4). Cálculo local, no genera operaciones.
  </p>

  <!-- Tasas + spread real -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Referencia mercado (Investing) — informativa, NO entra al modelo -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 0.95rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">show_chart</mat-icon>
          Referencia mercado (Investing)
        </h2>
      </div>
      <div class="p-4 flex flex-col items-center gap-1">
        <p class="text-2xl font-bold" style="color: #1e5a3f;">{{ investingRef ? (investingRef | number:'1.2-4') : '—' }}</p>
        <span class="text-xs text-gray-400 uppercase font-semibold">USD / COP · info</span>
        <span class="text-xs text-gray-500" *ngIf="investingFuente">{{ investingFuente }}</span>
        <span class="text-xs text-gray-400" *ngIf="investingFecha">{{ investingFecha }}</span>
        <span class="text-xs text-gray-400" *ngIf="cargandoTrm">Cargando…</span>
      </div>
    </div>

    <!-- Tasa pública de Vita (B3) — referencia del modelo -->
    <div class="bg-white rounded-2xl shadow-md border-2 overflow-hidden" style="border-color: #bbf7d0;">
      <div style="background: linear-gradient(135deg, #ecfdf5, #d1fae5); padding: 14px 20px; border-bottom: 2px solid #6ee7b7;">
        <h2 style="margin: 0; font-size: 0.95rem; font-weight: 700; color: #065f46; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #059669;">public</mat-icon>
          Tasa pública Vita (B3)
        </h2>
      </div>
      <div class="p-4 flex flex-col items-center gap-1">
        <p class="text-2xl font-bold" style="color: #065f46;">{{ trmVita ? (trmVita | number:'1.2-4') : '—' }}</p>
        <span class="text-xs text-gray-400 uppercase font-semibold">USD / COP · B3 (modelo)</span>
        <span class="text-xs text-gray-500" *ngIf="vitaPublicaFuente">{{ vitaPublicaFuente }}</span>
        <span class="text-xs text-gray-400" *ngIf="vitaPublicaFecha">{{ vitaPublicaFecha }}</span>
        <span class="text-xs text-gray-400" *ngIf="cargandoTrm">Cargando…</span>
      </div>
    </div>

    <!-- Vita COBREB real (B4) -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #eff6ff, #eef2ff); padding: 14px 20px; border-bottom: 2px solid #bfdbfe;">
        <h2 style="margin: 0; font-size: 0.95rem; font-weight: 700; color: #1e40af; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1d4ed8;">account_balance</mat-icon>
          Tasa compra Vita (BREB)
        </h2>
      </div>
      <div class="p-4 flex flex-col items-center gap-1">
        <ng-container *ngIf="cobrebDisponible !== false; else sinCobreb">
          <p class="text-2xl font-bold" style="color: #1e40af;">{{ trmSetup ? (trmSetup | number:'1.2-4') : '—' }}</p>
          <span class="text-xs text-gray-400 uppercase font-semibold">usd_sell · COBREB · B4</span>
          <span class="text-xs text-gray-500" *ngIf="vitaFixedCostCOP">Fee fijo: {{ vitaFixedCostCOP | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          <span class="text-xs text-gray-400" *ngIf="vitaValidUntil">Válida hasta: {{ vitaValidUntil | date:'dd/MM HH:mm' }}</span>
          <span class="text-xs text-gray-400" *ngIf="cargandoVita">Cargando…</span>
        </ng-container>
        <ng-template #sinCobreb>
          <p class="text-sm text-amber-600 text-center">COBREB sin precio publicado ahora. Tecleá la tasa de compra o se usará trmVita×0.995.</p>
        </ng-template>
        <span class="text-xs text-red-600" *ngIf="vitaError">{{ vitaError }}</span>
      </div>
    </div>

    <!-- Spread real (B5) -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #fef2f2, #fff7ed); padding: 14px 20px; border-bottom: 2px solid #fecaca;">
        <h2 style="margin: 0; font-size: 0.95rem; font-weight: 700; color: #b45309; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #d97706;">compare_arrows</mat-icon>
          Spread real (B5)
        </h2>
      </div>
      <div class="p-4 flex flex-col items-center gap-1">
        <p class="text-2xl font-bold" style="color: #b45309;">{{ resultado.pctSetup * 100 | number:'1.2-3' }}%</p>
        <span class="text-xs text-gray-400 text-center">1 − compra / pública</span>
        <span class="text-xs text-gray-500 text-center" *ngIf="usandoTasaRealVita">COBREB vs Vita pública</span>
        <span class="text-xs text-amber-600 text-center" *ngIf="!usandoTasaRealVita">Supuesto 0.5% (sin tasa COBREB real)</span>
      </div>
    </div>
  </div>

  <!-- Parámetros editables -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 0.95rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">tune</mat-icon>
        Parámetros (editables)
      </h2>
    </div>
    <div class="p-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
        Monto a enviar (USD)
        <input type="number" step="1" min="0" [(ngModel)]="montoUSD" (ngModelChange)="recalcular()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 font-bold" />
      </label>
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
        Tasa pública Vita (B3)
        <input type="number" step="0.01" [(ngModel)]="trmVita" (ngModelChange)="recalcular()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 font-normal" />
      </label>
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
        Tasa compra Vita (B4)
        <input type="number" step="0.01" [(ngModel)]="trmSetup" (ngModelChange)="recalcular()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 font-normal" />
      </label>
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
        Comisión Aguacate %
        <input type="number" step="0.0001" [(ngModel)]="aguacateFxPct" (ngModelChange)="recalcular()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 font-normal" />
      </label>
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
        Fijo Aguacate (USD)
        <input type="number" step="0.01" [(ngModel)]="aguacateFijo" (ngModelChange)="recalcular()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 font-normal" />
      </label>
    </div>
  </div>

  <!-- MODELO EXACTO (tarjeta cliente) -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6 max-w-2xl">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">point_of_sale</mat-icon>
        Modelo exacto — operación de {{ resultado.montoUSD | currency:'USD':'symbol':'1.0-0' }}
      </h2>
    </div>
    <div class="p-5" *ngIf="datosListos; else faltaDato">
      <div class="flex justify-between py-2 border-b border-gray-100">
        <span class="text-sm text-gray-500">Monto a enviar</span>
        <span class="text-sm font-bold text-gray-800">{{ resultado.montoUSD | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>
      <div class="flex justify-between py-2 border-b border-gray-100">
        <span class="text-sm text-gray-500">Tasa de referencia B3 (Vita pública)</span>
        <span class="text-sm font-semibold text-gray-700">{{ resultado.trmVita | number:'1.2-4' }}</span>
      </div>
      <div class="flex justify-between py-2 border-b border-gray-100">
        <span class="text-sm text-gray-500">Markup pantalla (C) para este monto ★</span>
        <span class="text-sm font-bold" style="color: #1C593D;">{{ resultado.markupPct | number:'1.4-6' }}%</span>
      </div>
      <div class="flex justify-between py-2 border-b border-gray-100">
        <span class="text-sm text-gray-500">Comisión Aguacate (visible)</span>
        <span class="text-sm font-semibold text-gray-700">{{ resultado.comisionAguacate | currency:'USD':'symbol':'1.2-4' }}</span>
      </div>
      <div class="flex justify-between py-3 mt-1 rounded-xl px-3" style="background: #f0fdf4;">
        <span class="text-sm font-bold" style="color: #1e5a3f;">Destinatario recibe ★</span>
        <span class="text-lg font-bold" style="color: #1e5a3f;">{{ resultado.copAguacate | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
      </div>
      <div class="flex justify-between py-2 mt-1 border-b border-gray-100">
        <span class="text-sm text-gray-500">Ganancia Aguacate</span>
        <span class="text-sm font-bold" [style.color]="resultado.gananciaAguacateUSD >= 0 ? '#1e40af' : '#b91c1c'">
          {{ resultado.gananciaAguacateUSD | currency:'USD':'symbol':'1.2-4' }}
        </span>
      </div>
      <div class="flex justify-between py-2">
        <span class="text-sm text-gray-500">Acreditación</span>
        <span class="text-sm font-semibold text-gray-700">menos de 1 hora</span>
      </div>
    </div>
    <ng-template #faltaDato>
      <div class="p-6 text-center text-sm text-gray-500">Falta la tasa de referencia o el monto.</div>
    </ng-template>
  </div>

  <!-- Tabla por montos con markup C por monto -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">table_chart</mat-icon>
        Tabla por montos — markup C3..C13 (varía por monto)
      </h2>
    </div>

    <!-- Desktop -->
    <div class="hidden lg:block overflow-x-auto" *ngIf="datosListos">
      <table mat-table [dataSource]="tabla" class="w-full">
        <ng-container matColumnDef="usd">
          <th mat-header-cell *matHeaderCellDef>USD origen</th>
          <td mat-cell *matCellDef="let r"><span class="text-xs font-bold text-gray-800">{{ r.montoUSD | currency:'USD':'symbol':'1.0-0' }}</span></td>
        </ng-container>
        <ng-container matColumnDef="markup">
          <th mat-header-cell *matHeaderCellDef>Markup % (C)</th>
          <td mat-cell *matCellDef="let r"><span class="text-xs font-bold" style="color: #1C593D;">{{ r.markupPct | number:'1.4-4' }}%</span></td>
        </ng-container>
        <ng-container matColumnDef="copAguacate">
          <th mat-header-cell *matHeaderCellDef>COP Aguacate</th>
          <td mat-cell *matCellDef="let r"><span class="text-xs font-bold" style="color: #1e5a3f;">{{ r.copAguacate | currency:'COP':'symbol-narrow':'1.0-0' }}</span></td>
        </ng-container>
        <ng-container matColumnDef="copVita">
          <th mat-header-cell *matHeaderCellDef>COP Vita</th>
          <td mat-cell *matCellDef="let r"><span class="text-xs text-gray-600">{{ r.copVita | currency:'COP':'symbol-narrow':'1.0-0' }}</span></td>
        </ng-container>
        <ng-container matColumnDef="comision">
          <th mat-header-cell *matHeaderCellDef>Comisión Agu.</th>
          <td mat-cell *matCellDef="let r"><span class="text-xs">{{ r.comisionAguacate | currency:'USD':'symbol':'1.2-2' }}</span></td>
        </ng-container>
        <ng-container matColumnDef="ganancia">
          <th mat-header-cell *matHeaderCellDef>Ganancia USD</th>
          <td mat-cell *matCellDef="let r">
            <span class="text-xs font-bold" [style.color]="r.gananciaAguacateUSD >= 0 ? '#1e40af' : '#b91c1c'">
              {{ r.gananciaAguacateUSD | currency:'USD':'symbol':'1.2-4' }}
            </span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Mobile -->
    <div class="lg:hidden space-y-3 p-4" *ngIf="datosListos">
      <div *ngFor="let r of tabla" class="bg-white rounded-xl shadow-sm border border-gray-200 p-3">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-bold text-gray-800">{{ r.montoUSD | currency:'USD':'symbol':'1.0-0' }}</span>
          <span class="text-xs font-bold" style="color: #1C593D;">Markup {{ r.markupPct | number:'1.4-4' }}%</span>
        </div>
        <div class="grid grid-cols-2 gap-2 text-xs text-gray-600">
          <div><span class="text-gray-400">COP Aguacate:</span> <span class="font-bold" style="color: #1e5a3f;">{{ r.copAguacate | currency:'COP':'symbol-narrow':'1.0-0' }}</span></div>
          <div><span class="text-gray-400">COP Vita:</span> {{ r.copVita | currency:'COP':'symbol-narrow':'1.0-0' }}</div>
          <div><span class="text-gray-400">Comisión:</span> {{ r.comisionAguacate | currency:'USD':'symbol':'1.2-2' }}</div>
          <div><span class="text-gray-400">Ganancia:</span> <span class="font-bold" [style.color]="r.gananciaAguacateUSD >= 0 ? '#1e40af' : '#b91c1c'">{{ r.gananciaAguacateUSD | currency:'USD':'symbol':'1.2-4' }}</span></div>
        </div>
      </div>
    </div>

    <div class="p-6 text-center text-sm text-gray-500" *ngIf="!datosListos">Cargá la tasa de referencia para ver la tabla.</div>
  </div>
</div>
